import React, { useCallback } from 'react';
import { AdminServiceEvents, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export const useRemoveMacl = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const removeMacl = useCallback(
        async (id: number) => {
            try {
                await services.api.call({
                    method: 'delete',
                    url: `/api/macls/${id}`,
                });

                // No response
                services.events.publish(events.macl_list_updated);
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.macl_list_updated]
    );

    return removeMacl;
};
